<template>
  <div class="all-stat">
    <div class="all-stat-large" v-if="isBigScreen">
      <img src="@/assets/stat/header.png" />
      <div class="all-stat-header">帕拉卡平台大数据信息大厅</div>
      <div class="all-stat-main">
        <div class="transition-box" :style="{ left: `${left}px` }">
          <div class="all-stat-main-one">
            <div class="all-stat-main-left all-stat-main-common">
              <AllStatLeft ref="allStatLeft" />
            </div>
            <div class="all-stat-main-center">
              <AllStatCenter ref="allStatCenter" />
            </div>
            <div class="all-stat-main-right all-stat-main-common">
              <AllStatRight ref="allStatRight" />
            </div>
          </div>
          <!-- <div class="all-stat-main-two">
            <div class="all-stat-main-two-left">
              <div class="all-stat-main-two-left-org">
                <OrgList @getOrgList="getOrgList" ref="orgList" />
              </div>
              <div class="all-stat-main-two-left-vip">
                <VipList @getVipList="getVipList" />
              </div>
            </div>
            <div class="all-stat-main-two-right">
              <UserProjectList />
            </div>
          </div> -->
        </div>
        <!-- <div class="pagination">
          <div :class="page === 1 ? 'active' : ''" @click="changePage(1)"></div>
          <div :class="page === 2 ? 'active' : ''" @click="changePage(2)"></div>
        </div> -->
      </div>
    </div>
    <div class="all-stat-small" v-if="!isBigScreen">
      <div class="all-stat-small-header">帕拉卡平台大数据信息大厅</div>
      <div class="all-stat-small-main">
        <AllStatCenter ref="allStatCenter" />
        <div class="all-stat-small-common all-stat-main-common">
          <AllStatLeft ref="allStatLeft" />
        </div>
        <div class="all-stat-small-common all-stat-main-common">
          <AllStatRight ref="allStatRight" />
        </div>
        <!-- <div class="all-stat-small-org">
          <OrgList @getOrgList="getOrgList" ref="orgList" />
        </div>
        <div class="all-stat-small-vip">
          <VipList @getVipList="getVipList" />
        </div>
        <UserProjectList /> -->
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters, mapActions } from 'vuex'
import AllStatLeft from './statOne/AllStatLeft'
import AllStatCenter from './statOne/AllStatCenter'
import AllStatRight from './statOne/AllStatRight'
import {
  yesterdayDate,
  monthStartDate,
  monthEndDate,
  oneMonthAgoStartDate,
  oneMonthAgoEndDate,
} from './constantDate'
// import OrgList from './statTwo/OrgList'
// import VipList from './statTwo/VipList'
// import UserProjectList from './statTwo/UserProjectList'
export default {
  name: 'AllStat',
  inject: ['reload'],
  components: {
    AllStatLeft,
    AllStatCenter,
    AllStatRight,
    // OrgList,
    // VipList,
    // UserProjectList,
  },
  data() {
    return {
      left: 0,
      page: 1,
      timer: null,
      isBigScreen: '',
    }
  },
  computed: {
    ...mapGetters({
      token: 'customer/token',
    }),
    regionCode() {
      return this.$route.query.regionCode
    },
    regionHasChild() {
      return _.includes(this.regionCode, '_full')
    },
    regionId() {
      return this.$route.query.regionId
    },
    regionName() {
      return this.$route.query.regionName
    },
    regionFullName() {
      return this.$route.query.regionFullName
    },
    sid() {
      return this.$route.query.sid
    },
  },
  created() {
    this.checkScreen()
    window.onresize = () => {
      this.checkScreen()
    }
  },
  watch: {
    regionId() {
      this.reload()
    },
    isBigScreen: {
      async handler() {
        if (!this.token) {
          const checked = await this.checkSid()
          if (checked === false) {
            return
          }
        }
        this.initStat()
      },
    },
  },
  methods: {
    ...mapActions({
      statPageGetRegionStats: 'statPage/getRegionStats',
      getStatRegionOverview: 'statPage/getStatRegionOverview',
      statPageGetRegionChildStats: 'statPage/getRegionChildStats',
      statPageGetChildrenArea: 'statPage/getChildrenArea',
      statPageGetGeoJson: 'statPage/getGeoJson',
      statPageGetUserProjectChoiceness: 'statPage/getUserProjectChoiceness',
      getVipPurchaseRecord: 'statPage/getVipPurchaseRecord',
      getAreaOrgs: 'statPage/getAreaOrgs',
      checkShareCode: 'newStat/checkShareCode',
      getShareDetail: 'newStat/getShareDetail',
    }),
    changePage(page) {
      this.page = page
      this.left = page === 1 ? 0 : -2548
    },
    async getYesterdayChildStat() {
      const yesterdayData = {
        sid: this.sid,
        regionId: this.regionId,
        startTime: yesterdayDate,
        endTime: yesterdayDate,
      }
      await this.statPageGetRegionChildStats(yesterdayData)
    },
    async getCurMonthStat() {
      const curData = {
        sid: this.sid,
        regionId: this.regionId,
        unit: 'day',
        startTime: monthStartDate,
        endTime: monthEndDate,
      }
      await this.statPageGetRegionStats(curData)
    },
    async getOneMonthAgoStat() {
      const oneMonthAgoData = {
        sid: this.sid,
        regionId: this.regionId,
        unit: 'day',
        startTime: oneMonthAgoStartDate,
        endTime: oneMonthAgoEndDate,
      }
      await this.statPageGetRegionStats(oneMonthAgoData)
    },
    // async getCurYearStat() {
    //   const curYearfirst = `${moment().format('YYYY')}-01-31`
    //   const curYearEnd = `${moment().format('YYYY')}-12-31`
    //   const curYearData = {
    //     sid: this.sid,
    //     regionId: this.regionId,
    //     unit: 'month',
    //     startTime: curYearfirst,
    //     endTime: curYearEnd,
    //   }
    //   await this.statPageGetRegionStats(curYearData)
    // },
    async getOneMonthAgoChildStat() {
      const oneMonthAgoData = {
        sid: this.sid,
        regionId: this.regionId,
        startTime: oneMonthAgoStartDate,
        endTime: oneMonthAgoEndDate,
      }
      await this.statPageGetRegionChildStats(oneMonthAgoData)
    },
    async getYesterdayStat() {
      const yesterdayStatData = {
        sid: this.sid,
        regionId: this.regionId,
        unit: 'day',
        startTime: yesterdayDate,
        endTime: yesterdayDate,
      }
      await this.getStatRegionOverview(yesterdayStatData)
    },
    async getVipList(data) {
      await this.getVipPurchaseRecord(data)
    },
    async getOrgList(data) {
      await this.getAreaOrgs(data)
    },
    async initStat() {
      await this.getCurMonthStat()
      await this.getOneMonthAgoStat()
      // await this.getCurYearStat()
      await this.getOneMonthAgoChildStat()
      // await this.getStatRegionOverview({
      //   regionId: this.regionId,
      //   sid: this.sid,
      // })
      await this.getYesterdayStat()
      await this.getYesterdayChildStat()
      await this.statPageGetChildrenArea(this.regionId)
      try {
        await this.statPageGetGeoJson(this.regionCode)
      } catch (err) {
        console.error(err)
      }
      await this.statPageGetUserProjectChoiceness()
      this.$refs.allStatLeft.init()
      this.$refs.allStatCenter.init()
      this.$refs.allStatRight.init()
      // this.$refs.orgList.initRegion()
    },
    async checkSid() {
      const shareSid = window.sessionStorage.getItem('shareSid')
      const shareCode = window.sessionStorage.getItem('shareCode')
      if (!shareSid) {
        window.open(`${location.origin}/#/share/${shareSid}`, '_self')
        return false
      }
      const shareDetail = await this.getShareDetail(shareSid)
      if (shareDetail.status === 0) {
        this.$message.error('该链接已关闭')
        return false
      }
      if (shareCode) {
        const { verified = false } = await this.checkShareCode({
          sid: shareSid,
          data: {
            passcode: shareCode,
          },
        })
        if (!verified) {
          this.$message.error('当前分享码已失效，请重新输入')
          window.sessionStorage.clear()
          window.open(`${location.origin}/#/share/${shareSid}`, '_self')
          return false
        }
      }
      return true
    },
    checkScreen() {
      if (this.timer) {
        clearTimeout(this.timer)
      }
      const clientWidth = document.body.clientWidth
      this.timer = setTimeout(() => {
        if (clientWidth > 2540) {
          this.isBigScreen = true
        } else {
          this.isBigScreen = false
        }
      }, 300)
    },
  },
}
</script>

<style lang='scss' scoped>
.all-stat {
  background: #1c2027;
  color: #fff;
  height: 100%;
  &-large {
    background: #1c2027;
    min-height: 1220px;
    min-width: 2548px;
  }
  & > img {
    display: block;
    margin: 0 auto;
  }
  &-header {
    margin: -300px 0 0px;
    width: 100%;
    text-align: center;
    font-size: 32px;
  }
  &-main {
    width: 2512px;
    padding-top: 30px;
    overflow: hidden;
    margin: 0 auto;
    position: relative;
    min-height: 1100px;
    .transition-box {
      position: absolute;
      left: 0px;
      width: 100%;
      transition: left 1s ease-in-out;
    }
    &-one {
      position: absolute;
      left: 0px;
      width: 100%;
      display: flex;
    }
    &-left,
    &-right {
      width: 726px;
      height: 1038px;
    }
    &-center {
      margin: 30px 20px;
      flex: 1;
    }
    &-common {
      background-color: #252a34;
      border: solid 1px #495482;
      box-sizing: border-box;
      border-radius: 4px;
    }
    .pagination {
      position: absolute;
      bottom: 20px;
      left: 0px;
      right: 0px;
      display: flex;
      justify-content: center;
      div {
        width: 30px;
        height: 10px;
        border-radius: 5px;
        background: linear-gradient(90deg, #252a34, #495482);
        cursor: pointer;
        transition: width 1s ease-in-out;
      }
      div:nth-of-type(2) {
        margin-left: 10px;
      }
      .active {
        width: 60px;
        background: linear-gradient(90deg, #495482, #106ffe);
      }
    }
  }
  .all-stat-main-two {
    position: absolute;
    left: 2548px;
    width: 2440px;
    display: flex;
    justify-content: space-between;
    padding: 0 40px;
    &-left {
      width: 1454px;
      &-org {
        height: 468px;
        margin-top: 30px;
        background: #252a34;
        margin-bottom: 30px;
      }
    }
    &-right {
      width: 920px;
    }
  }
}
.all-stat-small {
  background: #1c2027;
  min-height: 2000px;
  padding-bottom: 40px;
  &-header {
    background: url('../../assets/stat/header.png') no-repeat -764px 0px;
    height: 100px;
    line-height: 100px;
    text-align: center;
    font-size: 32px;
    width: 1020px;
    margin: 0 auto;
    margin-bottom: 26px;
  }
  &-main {
    width: 1020px;
    margin: 0 auto;
  }
  &-common {
    margin-top: 30px;
    padding: 0 100px;
  }
  &-org {
    position: relative;
    margin-top: 50px;
    padding-top: 2px;
    height: 680px;
  }
  &-vip {
    margin-top: 80px;
  }
}
</style>